import React from "react";

import { MemberProfileGoalsAndObjectiveNoteDisplayV2 } from "@/components/Provider/PatientView/MemberProfile/Notes/MemberProfileGoalsAndObjectiveNoteDisplayV2";

import {
  getCareGoalAndObjectiveNoteVersion,
  getCareGoalAndObjectivesFromNote,
} from "../../helpers/workflow-functions";

import { BehavioralGoals } from "./BehavioralGoals";

/**
 * Displays the goals and objectives or old care goals
 * in notes and the guided session
 */
export const MemberProfileNoteGoalsAndObjectiveDisplay = ({
  content,
  draftView,
  editable,
  editHandler,
  note,
  profileView,
}) => {
  const version = getCareGoalAndObjectiveNoteVersion(content);
  const goalAndObjectiveProgress = getCareGoalAndObjectivesFromNote(content, version);

  if (!goalAndObjectiveProgress) {
    return <></>;
  }

  return (
    <>
      {version === "1" && (
        <BehavioralGoals
          editable={editable}
          editHandler={editHandler}
          note={note}
          profileView={profileView}
        />
      )}

      {/* hide the display if there are no goals and objectives */}
      {version === "2" && Object.keys(goalAndObjectiveProgress).length !== 0 && (
        <MemberProfileGoalsAndObjectiveNoteDisplayV2
          draftView={draftView}
          editable={editable}
          editHandler={editHandler}
          goalAndObjectiveProgress={goalAndObjectiveProgress}
          profileView={profileView}
        />
      )}
    </>
  );
};
